




























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Endpoints} from '@/ts/store/Constants';
import Flyout from '@/components/Overlays/Flyout.vue';
import PreviewApplicationForm from '@/components/Admin/Forms/PreviewApplicationForm.vue';
import axios from 'axios';

@Component({
    components: {
        Flyout,
        PreviewApplicationForm,
    },
})
export default class ApplicationFlyout extends Vue {
    @Prop() public applicationData: any;

    public declineBtnStates: any =  ['new', 'active', 'accepted', 'passive'];
    public acceptBtnStates: any =  ['new', 'active', 'rejected', 'passive'];
    public passiveBtnStates: any =  ['new', 'active'];
    public activeBtnStates: any =  ['rejected', 'passive'];
    public previewBtnStates: any =  ['accepted', 'confirmed'];

    public activeComponent: string = 'PreviewApplicationForm';

    get isPreview(): boolean {
        return this.previewBtnStates.includes(this.applicationState);
    }

    get applicationState() {
        return this.$store.getters['WaitingLists/getPreviewedApplicationState'];
    }

    get modalTitle(): string {
        return this.isPreview
            ? this.$t('general.preview-application', 'Preview application')
            : this.$t('general.edit-application', 'Edit application');
    }

    public close() {
        (this.$refs.flyoutComponent as any).close();
    }

    public downloadLogs(applicationId: number) {
        axios({
            url: Endpoints.Admin.WaitingList.APPLICATION_EVENT_LOGS(applicationId),
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'event-logs.xlsx');
            document.body.appendChild(link);
            link.click();
        });
    }

    public declineApplication(applicationId: number) {
        (this.$refs.flyoutComponent as any).declineApplication(applicationId);
    }

    public acceptApplication(applicationId: number)  {
        (this.$refs.flyoutComponent as any).acceptApplication(applicationId);
    }

    public deleteApplication(applicationId: number) {
        (this.$refs.flyoutComponent as any).deleteApplication(applicationId);
    }

    public editApplication() {
        (this.$refs.flyoutComponent as any).editApplication();
    }

    public toggleApplicationActive(applicationId: number, active: string) {
        (this.$refs.flyoutComponent as any).toggleApplicationActive(applicationId, active);
    }
}
